const moduleI18n = {
    state: {
        locale: null,
        messageBundle: null,
        languageSelectionFlag: null,
    },
    mutations: {
        defineLanguageSelectionFlag(state, data) {
            state.languageSelectionFlag = data;
        },
        clearLanguageSelectionFlag(state) {
            state.languageSelectionFlag = null;
        },
        defineLocale(state, data) {
            /**console.log("define Locale:",data);*/
            state.locale = data;
        },
        clearLocale(state) {
            /**console.log("clear Locale:",state.locale);*/
            state.locale = null;
        },
        defineMessageBundle(state, data) {
            /**console.log("define MessageBundle:",data);*/
            state.messageBundle = data;
        },
        clearMessageBundle(state) {
            /**console.log("clear MessageBundle:",state.messageBundle);*/
            state.messageBundle = null;
        },
    },
    actions: {
        retrieveLanguageSelectionFlag({ commit, state }) {
            if (state.languageSelectionFlag === null || state.languageSelectionFlag === 'undefined') {
                if (typeof Storage !== 'undefined') {
                    const languageSelectionFlag = sessionStorage.getItem('languageSelectionFlag');
                    if (languageSelectionFlag) {
                        commit('defineLanguageSelectionFlag', languageSelectionFlag);
                    }
                }
            }
        },
        createLanguageSelectionFlag({ commit }, payload) {
            commit('defineLanguageSelectionFlag', payload);
        },
        removeLanguageSelectionFlag(context) {
            context.commit('clearLanguageSelectionFlag');
        },
        retrieveLocale({ commit, state }) {
            /**console.log("retrieveLocale:{}",state.locale);*/
            if (state.locale === null || state.locale === 'undefined') {
                if (typeof Storage !== 'undefined') {
                    const locale = sessionStorage.getItem('locale');
                    if (locale) {
                        commit('defineLocale', locale);
                    }
                }
            }
        },
        createLocale({ commit }, payload) {
            commit('defineLocale', payload);
        },
        removeLocale(context) {
            context.commit('clearLocale');
        },

        createMessageBundle({ commit }, payload) {
            commit('defineMessageBundle', payload);
        },
        removeMessageBundle(context) {
            context.commit('clearMessageBundle');
        },
    },
};

export default moduleI18n;
